import React, { useEffect} from 'react';

import Table from 'react-bootstrap/Table';
import { Button,Row , Col, Form } from 'react-bootstrap';

import * as Icon from 'react-bootstrap-icons';
import Modal from 'react-bootstrap/Modal';
function ServiceDetail({props}) {

  useEffect(() => {
    console.log(props);


  }, [])

  return (
    <>
        <Modal
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        show={props.smShow}
        autoFocus={true}
        centered={true}
        onHide={() => props.setSmShow(false)}

        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h6 className="d-flex justify-content-between align-items-center" >
                        Cliente {props.m.patente}
                    </h6>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Form>
                    <Row>
                        <Col sm={4} md={4} lg={4} >
                            <Form.Group className="mb-3" controlId="date">
                                <Form.Label>Fecha</Form.Label>
                                <Form.Control type="text" value={props.m.date}    readonly/>
                            </Form.Group>
                        </Col>

                        <Col sm={4} md={4} lg={4} >
                            <Form.Group className="mb-3" controlId="service">
                                <Form.Label>Servicio</Form.Label>
                                <Form.Control type="text" value={props.m.type}    readonly/>
                            </Form.Group>
                        </Col>

                        <Col sm={4} md={4} lg={4} >
                            <Form.Group className="mb-3" controlId="patente">
                                <Form.Label>Patente</Form.Label>
                                <Form.Control type="text" value={props.m.patente}    readonly/>
                            </Form.Group>
                        </Col>
                    </Row>
                    <hr/>
                    <Row>
                        {   Object.keys(props.m.details).map(function(k,v){
                                return <Col  md={4} lg={4} >
                                    <Form.Group className="mb-3" controlId={k}>
                                        <Form.Label>{k}</Form.Label>
                                        <Form.Control type="text" value={props.m.details[k]} readonly/>
                                    </Form.Group>
                                </Col>
                            })
                         }
                    </Row>
                    <Row>
                        {
                            <Col md={12} lg={12} >
                                <Form.Group className="mb-3" controlId="date">
                                    <Form.Label>Descripción</Form.Label>
                                    <Form.Control type="text" value={props.m.description}    readonly/>
                                </Form.Group>
                            </Col>
                        }
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    </>


  );
}

export default ServiceDetail;